//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CPOT_info",
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  }
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Trauma/CPOT_info.vue